import {Car} from "../../../models/car";
import {TranslateService} from "@ngx-translate/core";
import {ProdAppInjectorService} from "prod-shared";
import {marker as _translate} from "@biesbjerg/ngx-translate-extract-marker"


export class CarMapTemplate {
  static getIcon(car): string {
    let identity: string = car.numberPlate;
    let width = 250;
    if (!identity) {
      identity = car.vin;
    }

    return `<div class="car-icon ${CarMapTemplate.getClass(car)}" style="width: ${width}px; display: flex; flex-direction: row">&nbsp;
    <i class="material-icons marker">directions_car</i>&nbsp;<div class="" style="font-size: 14px">${identity}
    &nbsp;&nbsp;${car.equipment.lastBatteryEventVoltage.toFixed(2)} (V)
    </div>
    </div>`;
  }

  static getPopup(car): string {
    const translation = CarMapTemplate.getTranslation;
    return `<h4>${translation(_translate('car_map_template.details'))}</h4></h4><table class="table table-sm table-bordered table-striped">` +
      `<tr><td>${translation(_translate('car_map_template.organization'))}</td><td>` + car.equipment.organization.name + '</td></tr>' +
      `<tr><td>${translation(_translate('car_map_template.nationality'))}</td><td>` + car.nationality.code + '&nbsp;(' + car.nationality.country + ')</td></tr>' +
      `<tr><td>${translation(_translate('car_map_template.vin'))}</td><td>`+ car.vin + '</td></tr>' +
      `<tr><td>${translation(_translate('car_map_template.number_plate'))}</td><td>` + car.numberPlate + '</td></tr>' +
      `<tr><td>${translation(_translate('car_map_template.vhmd_id'))}</td><td>` + (car.vhmdId !== null ? car.vhmdId.name : '') + '</td></tr>' +
      `<tr><td>${translation(_translate('car_map_template.linked_at'))}</td><td>` + (car.equipment.linkedAt !== null ? car.equipment.linkedAt : '') + '</td></tr>' +
      `<tr><td>${translation(_translate('car_map_template.position'))}</td><td><a href="https://www.google.com/maps/place/` + car.equipment.latitude + ',' + car.equipment.longitude + '" target="_blank">' + car.equipment.latitude + ', ' + car.equipment.longitude + '</a></td></tr>' +
      `<tr><td>${translation(_translate('car_map_template.brand'))}</td><td>` + car.brand + '</td></tr>' +
      `<tr><td>${translation(_translate('car_map_template.model'))}</td><td>` + car.model + '</td></tr>' +
      `<tr><td>${translation(_translate('car_map_template.color'))}</td><td>` + car.color + '</td></tr>' +
      `<tr><td>${translation(_translate('car_map_template.parking_spot'))}</td><td>` + car.parkingSpotNumber + '</td></tr>' +
      `<tr><td>${translation(_translate('car_map_template.parked_at'))}</td><td>` + (car.parkedAt !== null ? car.parkedAt : '') + '</td></tr>' +
      `<tr><td>${translation(_translate('car_map_template.Last_battery_event_at'))}</td><td>` + (car.equipment.lastBatteryEventAt !== null ? car.equipment.lastBatteryEventAt : '') + '</td></tr>' +
      `<tr><td>${translation(_translate('car_map_template.Last_battery_event_voltage'))}</td><td>` + car.equipment.lastBatteryEventVoltage.toFixed(2) + ' (V)</td></tr>' +
      `<tr><td>${translation(_translate('car_map_template.status'))}</td><td>` + CarMapTemplate.statusColumnTransformer(car.equipment) + '</td></tr>' +
      '</table>';
  }

  static getTooltip(car): string {
    return '';
  }

  private static getDevices(car: Car): string {
    let devices: string = '';
    if (car.equipment && car.equipment.devices.length > 0) {
      car.equipment.devices.forEach(d => {
        devices += '<div>' +
          '<div>Name: ' + d.name + ' (' + d.deviceType.name + ')' + '</div>' +
          (d.lastEvent ? '<div>Voltage: ' + (d.lastEvent.batteryEvent.voltage).toFixed(2) + ' V</div>' : '') +
          '</div>';
      });
    }
    return devices;
  }

  private static getClass(car): string {
    switch (car.equipment.lastBatteryEventStatus) {
      case 'ALERTED':
        return 'bg-danger';
      case 'WARNED':
        return 'bg-warning';
      case 'OK':
        return 'bg-success';
    }
    return 'bg-secondary';
  }

  private static statusColumnTransformer(equipment) {
    let icon = document.createElement('i');
    icon.className = 'fa fa-battery-0';

    switch (equipment.lastBatteryEventStatus) {
      case 'OK': {
        icon.className = 'fa fa-battery-4 text-success';
        break;
      }
      case 'ALERTED': {
        icon.className = 'fa fa-battery-1 text-danger';
        break;
      }
      case 'WARNED': {
        icon.className = 'fa fa-battery-3 text-warning';
        break;
      }
    }

    return icon.outerHTML;
  }

  private static getTranslation(text: string) {
    const translate = ProdAppInjectorService.injector.get(TranslateService);
    return translate.instant(text);
  }
}
